export type AppConfig = {
    buildEnvironment: string
    luigiApiBaseUrl: string
    expertsApiBaseUrl: string
}

const buildEnvironment: string = process.env.ENV_BUILD_ENVIRONMENT!

export const appConfig: AppConfig = {
    buildEnvironment,
    luigiApiBaseUrl: process.env.ENV_LUIGI_BASE_URL!,
    expertsApiBaseUrl: process.env.ENV_EXPERTS_API_BASE_URL!,
}
